import { render, staticRenderFns } from "./MSelectList.vue?vue&type=template&id=2a362bd3&"
import script from "./MSelectList.ts?vue&type=script&lang=ts&"
export * from "./MSelectList.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports